import React from "react";
import { useHistory } from "react-router";
import pro from "../assets/images/banner1.png";
import GitHubIcon from "@material-ui/icons/GitHub";
import InstagramIcon from "@material-ui/icons/Instagram";
import FacebookIcon from "@material-ui/icons/Facebook";
import LinkedInIcon from "@material-ui/icons/LinkedIn";

const Banner = () => {
  const history = useHistory();
  return (
    <div className="bg-black text-white sm:flex sm:justify-between w-full md:h-screen lg:h-screen">
      <div className="px-3 py-3 sm:flex sm:flex-col sm:justify-center sm:ml-20">
        <h1 className="text-6xl text-yellow-400 font-bold sm:tracking-widest sm:text-7xl md:text-8xl lg:text-9xl mb-4">
          Pavan Rathod.
        </h1>
        <p className="text-lg text-white font-semibold tracking-widest ml-1 sm:ml-2">
          Full Stack Web Developer
        </p>

        <div className="ml-2 space-x-5 mt-5 flex items-center cursor-pointer">
          <a
            href="https://github.com/Pavanarathod?tab=repositories"
            target="_blank"
            rel="noopener noreferrer"
          >
            <GitHubIcon />
          </a>
          <a
            href="https://www.instagram.com/pavan_rathod_13/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <InstagramIcon />
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=100009401480614"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FacebookIcon />
          </a>

          <a
            href="https://www.linkedin.com/in/pavan-kumar-dr-b51b2a1b6/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <LinkedInIcon />
          </a>
        </div>

        <button
          onClick={() => history.push("/profile")}
          className="py-2 px-4 text-sm sm:w-44 ml-2  text-white border hover:bg-gray-50 hover:text-black border-gray-50 font-bold rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300 mt-4"
        >
          View profile{" "}
        </button>
      </div>

      <div className="px-3 py-3 sm:flex sm:justify-center">
        <img src={pro} alt="" className="object-contain " />
      </div>
    </div>
  );
};

export default Banner;
